<div class="item">
    @if (icon) {
        <span class="icon" [innerHTML]="icon"></span>
    }

    <div class="textWrapper">
        @if (titlePrefix?.text) {
            <span
                class="titlePrefix"
                [ngClass]="
                    titlePrefix?.textColor
                        ? 'titlePrefix--' + $safeNavigationMigration(titlePrefix?.textColor)
                        : 'titlePrefix--' + 'danger'
                "
                [innerHTML]="$safeNavigationMigration(titlePrefix?.text) | highlightText: inputText"
            ></span>
        }
        <span class="title" [ngClass]="{ disabled: disabled }" [innerHTML]="title | highlightText: inputText"></span>
        <span class="subtitle" [innerHTML]="subtitle | highlightText: inputText"></span>
    </div>
</div>
